import { Controller, useFormContext } from "react-hook-form";
import { Col, Row } from "../../shared/Layout";
import { HorizontalRadioList } from "../../shared/RadioList";
import { PLACEHOLDER_NONE } from "../../../constants/selectionValues";
import { INDIVIDUAL_SOLE_PROPRIETOR_OR_SINGLE_MEMBER_LLC } from "../../../constants/businessTaxClassifications";

const ExistingLLCTypeSelection = () => {
  const { control, setValue } = useFormContext();

  return (
    <Row>
      <Col lg={5} md={5} offset={{ lg: 2 }} sm={4}>
        <Controller
          control={control}
          name="isSingleMemberLLC"
          render={({ field: { value, onChange, ...rest }, fieldState: { error } }) => (
            <HorizontalRadioList
              id="isSingleMemberLLC"
              error={error?.message}
              legendText="Are you a single member LLC?"
              radios={[
                {
                  id: "isSMLLC_Radio_Yes",
                  label: "Yes",
                  value: "true",
                },
                {
                  id: "isSMLLC_Radio_No",
                  label: "No",
                  value: "false",
                },
              ]}
              value={value?.toString()}
              onChange={event => {
                if (event.target.value === "true") {
                  // set tax classification automatically, not that it matters since submit will already override this
                  setValue("taxClassification", INDIVIDUAL_SOLE_PROPRIETOR_OR_SINGLE_MEMBER_LLC);
                  onChange(true);
                } else {
                  // reset tax classification to clear old value when going to MMLLC
                  setValue("taxClassification", PLACEHOLDER_NONE);
                  onChange(false);
                }
              }}
              {...rest}
            />
          )}
        />
      </Col>
    </Row>
  );
};

export default ExistingLLCTypeSelection;
